export default "__VITE_ASSET__QxryoD7b__"